<template>
  <div id="home">
    <div class="banner text-white text-center py-4">
      <div class="container">
        <div class="text-uppercase font-weight-bold">
          Аттестация педагогических работников
        </div>
        <div>
          организаций, осуществляющих образовательную деятельность и находящихся
          в ведении Иркутской области, муниципальных и частных организаций,
          осуществляющих образовательную деятельность
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row my-0 mb-4">
        <div class="col-12">
          <VbAlert themeColor="danger" class="mt-3 mb-0">
            <div class="text-center">
              <strong>Уважаемые педагоги!</strong><br>
              Приём заявок в 25/26 учебном году завершён!<br>
              <span class="d-block mt-1">с 10 августа начнётся приём в 26/27 учебном году.</span>
            </div>
          </VbAlert>
          <!--<div class="alert alert-danger mt-3 mb-0" role="alert">-->
          <!--  <h4 class="alert-banner text-center">Уважаемые педагоги!</h4>-->
          <!--  <p class="alert-banner">-->
          <!--    Приём заявлений на 2024/2025 учебный год завершён!-->
          <!--  </p>-->
          <!--</div>-->
          <!--<div class="alert alert-danger mt-3 mb-0" role="alert">-->
          <!--<h4 class="alert-banner">-->
          <!--              Уважаемые педагоги!-->
          <!--              <br />-->
          <!--              Обращаем ваше внимание, что при подаче заявления для прохождения-->
          <!--              процедуры аттестации, прикрепляются 2 обязательных установленного-->
          <!--              образца и форма с результатами результатами профессиональной-->
          <!--              деятельности, заверенная работодателем. Заявление без данных-->
          <!--              прикрепленных документов не рассматриваются. Самостоятельно-->
          <!--              проверить загружены ли обязательные документы можно в личном-->
          <!--              кабинете, открыв раздел «детали заявления».-->
          <!--            </h4>-->
          <!--          </div>-->
          <div class="alert alert-danger mt-4 mb-0" role="alert" v-if="false">
            <h4 class="alert-banner">
              Уважаемые коллеги!
              <br />
              С 14:00 до 22:00 04.12.25 будут проходить технические работы!
              Система будет недоступна.
              <br />
              Приносим извинения за доставленные неудобства!
            </h4>
          </div>
        </div>
        <div class="col-12 col-sm-6 mt-4">
          <CardBootstrapCustomBS46 header class="h-100 shadow">
            <template v-slot:card-header>
              <h5 class="text-uppercase mb-0">
                Материалы для работы с системой
              </h5>
            </template>
            <template v-slot:card-body>
              <div v-if="fileResources.length > 0" class="row">
                <div
                  v-for="fileItem of fileResources"
                  :key="fileItem.id"
                  class="col-12 mt-2"
                >
                  <CardBootstrapCustomBS46 class="shadow-sm">
                    <template v-slot:card-body>
                      <div class="d-flex align-items-center">
                        <span class="material-icons text-primary mr-3"
                          >description</span
                        >
                        <a :href="url + fileItem.url.slice(1)" download>
                          {{ fileItem.title }}
                        </a>
                      </div>
                    </template>
                  </CardBootstrapCustomBS46>
                </div>
              </div>
              <div v-else class="alert alert-secondary mb-0" role="alert">
                Материалы для работы с системой ещё не загружены
              </div>
            </template>
          </CardBootstrapCustomBS46>
        </div>
        <div class="col-12 col-sm-6 mt-4">
          <CardBootstrapCustomBS46 header class="h-100 shadow">
            <template v-slot:card-header>
              <h5 class="text-uppercase mb-0">Авторизация</h5>
            </template>
            <template v-slot:card-body>
              <LoaderBootstrapCustomBS46
                v-if="authLoader.isLoading && !authLoader.isResponse"
                :comment="authLoader.comment"
                :theme="authLoader.theme"
              />
              <template v-else>
                <div
                  v-if="
                    authError.type === 'server' || authError.type === 'client'
                  "
                  class="alert alert-danger"
                  role="alert"
                >
                  <b>Ошибка!</b> {{ authError.text }}
                </div>
                <TheSignInFormBS46
                  v-if="!isAuthUser"
                  :app-loaded="appLoaded"
                  :sign-data="user.signInData"
                  :auth-error="authError"
                  @sign-in-local="$emit('sign-in-local', $event)"
                  @sign-in-esia="$emit('sign-in-esia', $event)"
                />
                <template v-else>
                  <p>
                    Вы авторизованы как пользователь
                    <b>{{ user.shortInfo.userName }}</b>
                  </p>
                  <p v-if="user.fullInfo.roles.length === 0">
                    У пользователя отсутствуют роли
                  </p>
                  <p
                    v-else-if="
                      user.fullInfo.roles.length === 1 &&
                      user.shortInfo.roleId === user.fullInfo.roles[0].label
                    "
                  >
                    Текущая роль -
                    <b>{{ user.fullInfo.roles[0].label }}</b>
                  </p>
                  <form v-else @submit.prevent>
                    <div class="form-group">
                      <label for="userRoleSelect">Роль пользователя</label>
                      <select
                        v-model="userRoleIdSelected"
                        class="form-control"
                        id="userRoleSelect"
                        @change="$emit('set-role', userRoleIdSelected)"
                      >
                        <option
                          v-if="
                            !userRoleIdSelected ||
                            (user.fullInfo.roles.length === 1 &&
                              user.shortInfo.roleId !==
                                user.fullInfo.roles[0].id)
                          "
                          value=""
                          selected
                          disabled
                        >
                          Выберите роль
                        </option>
                        <option
                          v-for="role of user.fullInfo.roles"
                          :key="role.id"
                          :value="role.id"
                          :selected="role.id === userSelectedRoleId"
                        >
                          {{ role.label }}
                        </option>
                      </select>
                    </div>
                  </form>
                  <button class="btn btn-primary" @click="$emit('sign-out')">
                    Выход
                  </button>
                </template>
              </template>
            </template>
          </CardBootstrapCustomBS46>
        </div>
        <div class="col-12 mt-4">
          <CardBootstrapCustomBS46 header class="h-100 shadow">
            <template v-slot:card-header>
              <h5 class="text-uppercase mb-0">График проведения аттестации</h5>
            </template>
            <template v-slot:card-body>
              <div class="table-responsive">
                <!-- <div v-html="expertisesSchedule"></div> -->
                <div data-v-769ad999="" class="timetable">
                  <div data-v-769ad999="" class="timetable__column">
                    <div data-v-769ad999="" class="timetable__cell">Месяц</div>
                    <div data-v-769ad999="" class="timetable__cell">
                      Сентябрь
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      Октябрь
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">Ноябрь</div>
                    <div data-v-769ad999="" class="timetable__cell">
                      Декабрь
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">Январь</div>
                    <div data-v-769ad999="" class="timetable__cell">
                      Февраль
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">Март</div>
                    <div data-v-769ad999="" class="timetable__cell">Апрель</div>
                    <div data-v-769ad999="" class="timetable__cell">Май</div>
                  </div>
                  <div data-v-769ad999="" class="timetable__column">
                    <div data-v-769ad999="" class="timetable__cell">
                      Сроки подачи заявления и предоставления документов
                      оператору
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.08 по 09.09.26
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.09 по 09.10.26
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.10 по 09.11.26
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.11 по 09.12.26
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.12 по 09.01.27
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.01 по 09.02.27
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.02 по 09.03.27
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.03 по 09.04.27
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      с 10.04 по 09.05.27
                    </div>
                  </div>
                  <div data-v-769ad999="" class="timetable__column">
                    <div data-v-769ad999="" class="timetable__cell">
                      Начало аттестации
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      21 сентября
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      19 октября
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      16 ноября
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      21 декабря
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      18 января
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      22 февраля
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      22 марта
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      19 апреля
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">17 мая</div>
                  </div>
                  <div data-v-769ad999="" class="timetable__column">
                    <div data-v-769ad999="" class="timetable__cell">
                      Подведения итогов аттестации
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      12 ноября
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      17 декабря
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      14 января
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      18 февраля
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      18 марта
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">
                      15 апреля
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">13 мая</div>
                    <div data-v-769ad999="" class="timetable__cell">
                      10 июня
                    </div>
                    <div data-v-769ad999="" class="timetable__cell">8 июля</div>
                  </div>
                </div>
              </div>
            </template>
          </CardBootstrapCustomBS46>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardBootstrapCustomBS46 from "../components/universal/CardBootstrapCustomBS46";
import TheSignInFormBS46 from "../components/TheSignInFormBS46";
import LoaderBootstrapCustomBS46 from "../components/universal/LoaderBootstrapCustomBS46";
import VbAlert from "../components/universal/BS46Alert.vue";

export default {
  name: "HomeView",
  components: {
    LoaderBootstrapCustomBS46,
    TheSignInFormBS46,
    CardBootstrapCustomBS46,
    VbAlert,
  },
  props: [
    "appLoaded",
    "url",
    "user",
    "userSelectedRoleId",
    "isAuthUser",
    "authLoader",
    "newsList",
    "authError",
    "messagesTable",
    "fileResources",
    "expertisesSchedule",
  ],
  data() {
    return {
      userRoleIdSelected: "",
    };
  },

  watch: {
    userSelectedRoleId: function () {
      this.userRoleIdSelected = this.userSelectedRoleId;
    },
  },

  async created() {
    await this.$emit("get-home-view-data");
  },

  mounted: function () {
    this.userRoleIdSelected = this.userSelectedRoleId;
  },
};
</script>
